import React from "react";
import {Route} from "react-router-dom";

const module = (shopApp) => {
	const NewProducts = shopApp.dynamic(() => import("./NewProducts"));

	const url = "/new_products";

	let config = {
		name: "NewProducts",
		routes: [
			<Route key={url} exact path={url} component={NewProducts}/>
		]
	};

	shopApp.registerPage(config);

};

export default module;
